import { TextField } from "@mui/material";
import { MRT_Row, MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext } from "./ColumnHelpers";
import { columnDisplayNames } from "../../../admin/ImportSettings";
import { getValidationErrorKey } from "../../../../utilities/jobValidation";
import { CREATE_NEW_SALESPERSON } from "../../../../utilities/constants";

export function column_SalespersonPhone(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return {
		id: "salespersonMobilePhone",
		header: columnDisplayNames.salespersonMobilePhone,
		accessorFn: () => "", // Dummy accessor since this is a computed column
		enableEditing: false, // We handle editing in the Cell component
		size: 150,
		Cell: ({ row }: { row: MRT_Row<Job> }) => {
			const jobId = row.original.id;
			const job = context.jobs.find((j) => j.id === jobId);
			const hasNewSalesperson = job?.salespersonIds?.includes(CREATE_NEW_SALESPERSON);

			// Merge props.salespersons with newSalespersons for all available options
			const allSalespersons = [...(context.props.salespersons || []), ...context.newSalespersons];

			// Determine the value and if it's editable
			let value = "";
			let isEditable = false;

			if (hasNewSalesperson) {
				value = job?.newSalesperson?.phone || "";
				isEditable = true;
			} else {
				// Existing salesperson - find from merged list and make read-only
				const selectedSalesperson = allSalespersons.find((contact) => job?.salespersonIds?.includes(contact.id));
				value = selectedSalesperson?.mobilePhone || "";
				isEditable = false;
			}

			const errorKey = getValidationErrorKey("salespersonMobilePhone", jobId);
			const hasError = isEditable && !!context.validationErrors?.[errorKey];

			return (
				<TextField
					size="small"
					style={{ width: "100%", padding: 0 }}
					value={value}
					disabled={!isEditable}
					variant="outlined"
					error={hasError}
					helperText={hasError ? context.validationErrors[errorKey] : undefined}
					sx={
						hasError
							? {
									"& .MuiOutlinedInput-root": {
										"& fieldset": {
											borderColor: "error.main",
											borderWidth: "2px",
										},
									},
									"& .MuiFormHelperText-root": {
										color: "error.main",
										fontSize: "0.75rem",
									},
								}
							: {}
					}
					InputProps={{
						readOnly: !isEditable,
					}}
					onChange={
						isEditable
							? (event) => {
									const phoneValue = event.target.value;

									const newJobs = [...context.jobs];
									const currentJob = newJobs.find((j) => j.id === jobId);
									if (currentJob && currentJob.newSalesperson) {
										currentJob.newSalesperson.phone = phoneValue;

										// Also update phone in newSalespersons if it exists
										const salespersonName = currentJob.newSalesperson.name;
										const updatedNewSalespersons = context.newSalespersons.map((sp) => {
											if (sp.name === salespersonName) {
												return { ...sp, mobilePhone: phoneValue };
											}
											return sp;
										});
										context.setNewSalespersons(updatedNewSalespersons);

										// Update jobs state and trigger validation
										context.setJobs(newJobs);
										context.validateJobs([currentJob], { updateState: true, clearPrevious: false });
									}
								}
							: undefined
					}
					placeholder={isEditable ? `Enter phone` : ""}
				/>
			);
		},
	};
}
